import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { getActiveLanguage } from '@teamfoster/sdk/language-ngrx';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  activeLanguage$!: Observable<string>;

  constructor(
    private store: Store,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Allow only requests to your own API to get the Language header
    const isShopify = req.url.includes(environment.storeDomain);

    if (isShopify) {
      return next.handle(req); // Don't modify Shopify or 3rd party requests
    }

    return this.store.select(getActiveLanguage).pipe(
      take(1),
      switchMap(lang =>
        next.handle(
          req.clone({
            headers: req.headers.set('Language', `${lang}`),
          })
        )
      )
    );
  }
}
